import { publicClient, privateClient } from './client';
import { InventoryAvailability } from './InventoryAvailability';

const transactionsInventoryAvailability = (pub: boolean) => new InventoryAvailability(pub ? publicClient : privateClient);
export default transactionsInventoryAvailability;
